'use strict';

var ConfigurationFoMarketsDirective = function ConfigurationFoMarketsDirective() {
  return {
    restrict: 'E',
    controller: 'ConfigurationFoMarketsController',
    template: require('../templates/configuration-fo-markets.html'),
    link: function link($scope, element) {
      $scope.isValidationMessage = function () {
        var validationMessageCssDisplay = element.find('.jqx-grid-validation').css('display');
        return validationMessageCssDisplay && validationMessageCssDisplay !== 'none';
      };
    }
  };
};
ConfigurationFoMarketsDirective.$inject = [];
module.exports = ConfigurationFoMarketsDirective;